import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./Auth/authSlice";
import recordedContactReducer from "./RecordedContacts/recordedContactsSlice";
import thirdPartyContactReducer from "./ThirdPartyContacts/thirdPartyContactsSlice";
import notificationsReducer from "./Notifications/notificationsSlice";
import userReducer from "./Users/usersSlice";
import recordedCallReducer from "./RecordedCalls/recordedCallsSlice";
import playlistReducer from "./Playlists/playlistsSlice";
import recordedContactInsightsReducer from "./RecordedContactInsights/recordedContactsInsightsSlice";
import reportReducer from "./Reports/reportsSlice";

const store = configureStore({
  reducer: {
    notifications: notificationsReducer,
    auth: authReducer,
    recordedContacts: recordedContactReducer,
    thirdPartyContacts: thirdPartyContactReducer,
    users: userReducer,
    recordedCalls: recordedCallReducer,
    playlists: playlistReducer,
    recordedContactsInsights: recordedContactInsightsReducer,
    reports: reportReducer,
  },
});

export default store;
